"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableDemonstrative", {
  enumerable: true,
  get: function get() {
    return _TableDemonstrative.default;
  }
});
var _TableDemonstrative = _interopRequireDefault(require("./TableDemonstrative.vue"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }